import React from 'react'
import { CenterPanel } from 'view/routes/routesLayout'
import { ProductHeroPanel } from './ProductHeroPanel'
import { ProductGrid } from './ProductGrid'

export const ProductScreen: React.FC = () => (
  <CenterPanel>
    <ProductHeroPanel />
    <ProductGrid />
  </CenterPanel>
)
